import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SidebarLinks from "./SidebarLinks";
import axios from "axios";
import {
  DELETE_WISHLIST_API,
  GET_WISHLIST_API,
  POST_ADD_WISHLIST_API,
} from "../app/constants";
import { BASE_URL } from "..";

const Wishlist = () => {
  const [cartArray, setCartArray] = useState([
    {
      id: 1,
      productName: "Taylor Farms Broccoli Florets",
      productImg: "assets/images/thumbs/product-two-img1.png",
      productPrice: 5.99,
      quantity: 1,
      description:
        "Freshly picked broccoli florets, perfect for healthy meals.",
      isChecked: true,
    },
    {
      id: 2,
      productName: "Fresh Strawberries",
      productImg: "assets/images/thumbs/product-two-img2.png",
      productPrice: 130.49,
      quantity: 2,
      description:
        "Sweet and juicy strawberries, great for desserts or snacks.",
      isChecked: true,
    },
    {
      id: 3,
      productName: "Organic Avocado",
      productImg: "assets/images/thumbs/product-two-img3.png",
      productPrice: 2.99,
      quantity: 3,
      description: "Creamy organic avocados, rich in nutrients and flavor.",
      isChecked: false,
    },
    {
      id: 4,
      productName:
        "All-Natural Honeycomb Freshly Harvested from Local Bee Farms",
      productImg: "assets/images/thumbs/product-two-img1.png",
      productPrice: 19.99,
      quantity: 1,
      description:
        "Pure honeycomb straight from the hive, packed with natural sweetness and health benefits.",
      isChecked: true,
    },
    {
      id: 5,
      productName:
        "Certified Organic Free-Range Chicken Breast, Humanely Raised",
      productImg: "assets/images/thumbs/product-two-img2.png",
      productPrice: 15.49,
      quantity: 2,
      description:
        "Tender and juicy chicken breasts, raised without antibiotics or hormones, perfect for healthy meals.",
      isChecked: false,
    },
    {
      id: 6,
      productName:
        "Premium Wild-Caught Alaskan Salmon Filets, Sustainably Sourced",
      productImg: "assets/images/thumbs/product-two-img3.png",
      productPrice: 24.99,
      quantity: 3,
      description:
        "Fresh, wild-caught salmon fillets, packed with omega-3 fatty acids and perfect for grilling or baking.",
      isChecked: true,
    },
    {
      id: 7,
      productName:
        "Delicious Vegan Gluten-Free Chocolate Chip Cookies, Handcrafted with Organic Ingredients",
      productImg: "assets/images/thumbs/product-two-img1.png",
      productPrice: 8.99,
      quantity: 1,
      description:
        "Indulge in the rich flavor of vegan, gluten-free chocolate chip cookies made with organic ingredients.",
      isChecked: false,
    },
    {
      id: 8,
      productName:
        "Artisanal Aged Parmigiano Reggiano Cheese, 24-Month-Old, Imported from Italy",
      productImg: "assets/images/thumbs/product-two-img2.png",
      productPrice: 39.99,
      quantity: 1,
      description:
        "Handcrafted Parmigiano Reggiano cheese aged for 24 months, offering a rich, nutty flavor perfect for pasta or salads.",
      isChecked: true,
    },
    {
      id: 9,
      productName:
        "Exotic Blueberry and Raspberry Fusion Smoothie Mix with Organic Superfoods",
      productImg: "assets/images/thumbs/product-two-img3.png",
      productPrice: 12.49,
      quantity: 1,
      description:
        "A nutrient-packed smoothie mix combining organic blueberries, raspberries, and superfoods for a healthy boost.",
      isChecked: true,
    },
    {
      id: 10,
      productName:
        "Freshly Squeezed Cold-Pressed Organic Orange Juice, No Added Sugars or Preservatives",
      productImg: "assets/images/thumbs/product-two-img1.png",
      productPrice: 6.99,
      quantity: 2,
      description:
        "A refreshing, natural orange juice made from 100% organic oranges with no added sugars or preservatives.",
      isChecked: false,
    },
    {
      id: 11,
      productName:
        "Handmade Artisan Italian Focaccia Bread with Fresh Rosemary and Sea Salt",
      productImg: "assets/images/thumbs/product-two-img2.png",
      productPrice: 4.99,
      quantity: 1,
      description:
        "Deliciously soft, rosemary-infused focaccia bread, baked fresh and perfect as a side for any meal.",
      isChecked: true,
    },
    {
      id: 12,
      productName:
        "Superfood Acai Berry Powder Blend, Freeze-Dried for Maximum Nutrient Retention",
      productImg: "assets/images/thumbs/product-two-img3.png",
      productPrice: 22.49,
      quantity: 1,
      description:
        "Organic acai berry powder, freeze-dried to preserve nutrients, perfect for smoothies, bowls, and snacks.",
      isChecked: false,
    },
  ]);

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);

  const [showDelModal, setShowDelModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);

  const handleCloseDelModal = () => {
    setShowDelModal(false);
    setSelectedProductId(null);
  };

  const handleShowDelModal = (productId) => {
    setShowDelModal(true);
    setSelectedProductId(productId);
  };
  const handleShowModal = () => {
    const selectedItems = cartArray.filter((item) => item.isChecked);
    if (selectedItems.length > 0) {
      setShowModal(true);
    } else {
      // toast.error("Please select a product to delete.");
    }
  };

  const [activeTab, setActiveTab] = useState(0);
  const [wishlist, setWishlist] = useState([]);
  const [pastPurchases, setPastPurchases] = useState([]);
  const [followedStores, setFollowedStores] = useState([]);

  const tabs = [
    {
      tab: `My Wishlist (${wishlist.length})`,
      fetchData: async () => {
        try {
          const token = localStorage.getItem("accessToken");
          const response = await axios.get(`${BASE_URL}${GET_WISHLIST_API}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (response.data.code === 1) {
            return response.data.data;
          }
        } catch (error) {
          console.error("Error fetching wishlist:", error);
        }
      },
    },

    // {
    //   tab: "Followed Stores",
    //   fetchData: async () => {
    //     try {
    //       const token = localStorage.getItem("accessToken");
    //       const response = await axios.get(
    //         // `${BASE_URL}${GET_FOLLOWED_STORES_API}`,
    //         {
    //           headers: { Authorization: `Bearer ${token}` },
    //         }
    //       );
    //       if (response.data.code === 1) {
    //         return response.data.data;
    //       }
    //     } catch (error) {
    //       console.error("Error fetching followed stores:", error);
    //     }
    //   },
    // },
  ];

  // Handle tab change by index
  const handleTabChange = async (index) => {
    setActiveTab(index);

    const selectedTab = tabs[index];
    if (selectedTab && selectedTab.fetchData) {
      const data = await selectedTab.fetchData();

      if (index === 0) {
        setWishlist(data);
      } else if (index === 1) {
        setPastPurchases(data);
      } else if (index === 2) {
        setFollowedStores(data);
      }
    }
  };

  useEffect(() => {
    handleTabChange(0);
  }, []);

  const handleRemoveFromWishlist = async (productId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.delete(
        `${BASE_URL}${DELETE_WISHLIST_API}?productId=${productId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === 1) {
        // Handle success (you can update the wishlist state here)
        console.log("Item removed from wishlist", productId);
        // Example: You might want to update your local wishlist or refetch the data
      } else {
        console.error("Failed to remove item from wishlist");
      }
    } catch (error) {
      console.error("Error removing item from wishlist:", error);
    }
  };

  const totalLength = `${wishlist.length}`;

  return (
    <section className="payment py-40 bg-light-100">
      {/* pop up for add to cart */}
      {showModal && (
        <div>
          <div
            className="modal-overlay flex-center position-fixed top-0 w-100 h-100 z-2"
            onClick={handleCloseModal}
            style={{
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
            }}
          ></div>
          <div
            className="modal-content p-20 bg-white shadow-lg position-fixed top-50 start-50 translate-middle w-md-90 w-lg-auto z-3"
            style={{ maxWidth: "20rem" }}
          >
            <p className="text-black text-xl">Add All to Cart</p>
            <p className="text-muted text-xs">
              Are you sure you want to add all these products to your cart?
            </p>
            <div className="modal-actions d-flex justify-content-end mt-26 gap-24">
              <button
                className="btn-cancel text-muted"
                onClick={handleCloseModal}
              >
                NO
              </button>
              <button className="btn-confirm bg-main text-success">YES</button>
            </div>
          </div>
        </div>
      )}
      {/*  */}

      {/* pop up for del */}
      {showDelModal && (
        <div>
          <div
            className="modal-overlay flex-center position-fixed top-0 w-100 h-100 z-2"
            onClick={handleCloseDelModal}
            style={{
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
            }}
          ></div>
          <div
            className="modal-content p-20 bg-white shadow-lg position-fixed top-50 start-50 translate-middle w-md-90 w-lg-auto z-3"
            style={{ maxWidth: "20rem" }}
          >
            <p className="text-black text-xl">Delete</p>
            <p className="text-muted text-xs">
              Are you sure you want to remove this products from wishlist?
            </p>
            <div className="modal-actions d-flex justify-content-end mt-26 gap-24">
              <button
                className="btn-cancel text-muted"
                onClick={handleCloseDelModal}
              >
                NO
              </button>
              <button
                className="btn-confirm bg-main text-success"
                onClick={async () => {
                  if (selectedProductId) {
                    await handleRemoveFromWishlist(selectedProductId);
                    window.location.reload();
                  }
                }}
              >
                YES
              </button>
            </div>
          </div>
        </div>
      )}
      {/*  */}
      <div className="container container-lg px-lg-5">
        <div className="row flex-row-reverse gy-4">
          <div className="col-xl-9 col-lg-8  px-24 ">
            <h4 className="fw-medium">My Wishlist ({totalLength})</h4>
            <div
              className="d-flex justify-content-sm-between justify-content-lg-start gap-14 mt-64 align-items-lg-start "
              style={{ borderBottom: "1px solid gray" }}
            >
              {tabs.map((item, index) => (
                <div
                  key={index}
                  className={`text-black payment-upper flex-center flex-column fw-bold cursor-pointer text-capitalize ${
                    activeTab === index ? "text-black" : "text-muted"
                  }`}
                  style={{
                    borderBottom: activeTab === index ? "3px solid black" : "",
                  }}
                  onClick={() => setActiveTab(index)}
                >
                  <i
                    className={`${item.icon} text-4xl`}
                    style={{ color: item.iconColor }}
                  ></i>
                  <p className="text-nowrap text-sm">{item.tab}</p>
                </div>
              ))}
            </div>
            {/* <div className="bg-white ">
              <button
                className={`text-primary p-10 my-20 ${
                  activeTab === 0 ? "d-block" : "d-none"
                }`}
                onClick={() => {
                  handleShowModal();
                }}
              >
                ADD ALL TO CART
              </button>
            </div> */}

            <div className="row justify-content-center mx-0">
              {tabs.map((item, index) => (
                <div
                  key={index}
                  className={`col-xl-9 col-lg-8 h-100 bg-light py-12 w-100 text-capitalize ${
                    activeTab === index ? "d-block" : "d-none"
                  }`}
                  style={{
                    transform: activeTab === index ? "scale(1)" : "scale(0.95)",
                  }}
                >
                  <p className="mb-3 ">{item.descrption} </p>
                </div>
              ))}
            </div>
            {/* table */}

            <div>
              {/* Table for Wishlist (only shown when activeTab is 0) */}
              {activeTab === 0 && (
                <div className="cart-table">
                  {!wishlist || wishlist.length === 0 ? (
                    <div className="empty-cart text-center">
                      <h4>Your wishlist is empty!</h4>
                    </div>
                  ) : (
                    <div className="overflow-x-auto scroll-sm-horizontal">
                      <table className="table bg-color-three border-top-0 border-right-0 border-left-0">
                        <tbody>
                          {wishlist.map((item) => (
                            <tr key={item.productId}>
                              <td className="align-middle text-center">
                                <div className="table-product d-flex align-items-center gap-24">
                                  <Link
                                    to={`/product/${item.slug}`}
                                    className="table-product__thumb rounded-8 flex-center"
                                    aria-label={`View details of ${item.title}`}
                                  >
                                    <img
                                      src={item.image}
                                      alt={item.title}
                                      className="img-fluid"
                                    />
                                  </Link>
                                </div>
                              </td>
                              <td className="align-middle text-center">
                                <div className="table-product__content text-start">
                                  <h6
                                    className="title text-lg fw-semibold mb-8"
                                    style={{ minWidth: "3rem" }}
                                  >
                                    <Link
                                      to={`/product/${item.slug}`}
                                      className="link text-line-2"
                                      tabIndex={0}
                                      aria-label={`View details of ${item.title}`}
                                    >
                                      {item.title}
                                    </Link>
                                  </h6>
                                  {item.description && (
                                    <h6 className="title text-sm fw-semibold mb-8 text-muted d-none d-md-block">
                                      {item.description}
                                    </h6>
                                  )}
                                </div>
                              </td>
                              <td
                                className="align-middle"
                                style={{ minWidth: "5rem" }}
                              >
                                <span className="text-lg text-main h6 mb-0 text-nowrap">
                                  Rs.{item.offered}
                                </span>

                                {item.selling && (
                                  <div className="text-decoration-line-through text-sm mb-0 fw-semibold text-muted">
                                    Rs.{item.selling}
                                  </div>
                                )}
                              </td>
                              <td className="align-middle text-center">
                                <button className="btn bg-main-600 text-white">
                                  <i
                                    className="bi bi-trash text-white cursor-pointer text-lg"
                                    onClick={() =>
                                      handleShowDelModal(item.productId)
                                    }
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* table end */}
          </div>
          <div className="col-xl-3 col-lg-4 h-100 position-sticky top-0">
            <SidebarLinks />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Wishlist;
